import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { VaAlert } from '@department-of-veterans-affairs/component-library/dist/react-bindings';
import { useFeatureToggle } from 'platform/utilities/feature-toggles';
import { focusByOrder } from 'platform/utilities/ui/focus';
import localStorage from 'platform/utilities/storage/localStorage';

export const SITE_WIDE_MESSAGE = {
  id: 'site-wide-111126-msg',
  status: 'info',
  text: 'Learn about new improvements to VA.gov',
  href: '/resources/new-improvements-to-your-vagov-experience/',
};

// Keyed by message id so a future message isn't suppressed by this dismissal.
export const DISMISSED_KEY = `dismissed-${SITE_WIDE_MESSAGE.id}`;

// Next logical spot after the alert: the breadcrumbs, else the page heading.
export const FOCUS_AFTER_DISMISS = ['va-breadcrumbs>>shadow>>nav li > a', 'h1'];

export default function SiteWideMessage() {
  const { TOGGLE_NAMES, useToggleValue, useToggleLoadingValue } =
    useFeatureToggle();
  const isToggleOn = useToggleValue(TOGGLE_NAMES.siteWide111126Msg);
  const isLoadingToggles = useToggleLoadingValue();
  const isLoggedIn = useSelector(
    state => state?.user?.login?.currentlyLoggedIn,
  );
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(DISMISSED_KEY) === 'true',
  );
  const shouldRender =
    !isLoadingToggles &&
    isToggleOn &&
    !isLoggedIn &&
    !dismissed &&
    localStorage.getItem('hasSession') !== 'true';

  const handleClose = () => {
    localStorage.setItem(DISMISSED_KEY, 'true');
    setDismissed(true);
    focusByOrder(FOCUS_AFTER_DISMISS);
  };

  if (!shouldRender) {
    return null;
  }

  return (
    <div
      role="region"
      aria-label="Message about recent changes"
      className="vads-grid-container vads-u-padding-x--0 vads-u-margin-top--1p5"
      data-testid="site-wide-message-container"
    >
      <VaAlert
        slim
        closeable
        closeBtnAriaLabel="Close message about recent changes"
        status={SITE_WIDE_MESSAGE.status}
        onCloseEvent={handleClose}
        data-testid="site-wide-message"
      >
        <p className="vads-u-margin--0">
          <span className="sr-only">Announcement: </span>
          <va-link
            href={SITE_WIDE_MESSAGE.href}
            text={SITE_WIDE_MESSAGE.text}
          />
        </p>
      </VaAlert>
    </div>
  );
}
